// 购物车store
import { listCart,delCart,updateCart,addCart } from '@/api/cart';

const getDefaultState = () =>{
  return {
    total: 0,
    cartList: [],
    banners:[],
    page:1,
    limit:9999
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_CARTLIST: (state, cartList) => {
      state.cartList = cartList
    },
    SET_BANNERS: (state, banners) => {
      state.banners = banners
    },
    SET_PAGE: (state, page) => {
      state.page = page
    },
    SET_LIMIT: (state, limit) => {
      state.limit = limit
    },
    RESET_STATE:(state, payload) =>{
      Object.assign(state, payload)
    }
  },
  getters: {
    total: state => state.total,
    cartList: state => state.cartList,
    banners: state => state.banners
  },
  actions: {
    GetCartList({ commit, state }){
      const { page,limit } = state
      listCart({ page,limit }).then((res) => {
        if (res.code == 200) {
          const { count,data } = res;
          const { banners,list } = data
          const temp = []
          list.map(((item, index)=> {
            temp.push(Object.assign({},item,{ isSelect:false,disabled:!item.storage }))
          }))
          commit('SET_CARTLIST', temp)
          commit('SET_TOTAL', count)
          commit('SET_BANNERS', data.banners)
        }
      });
    },
    RemoveCart({ dispatch, commit, state }, payload){
      const { cart_ids } = payload
      const { page,limit } = state
      return new Promise((resolve, reject) => {
        delCart({ cart_ids }).then(res=>{
          dispatch('GetCartList',{ page,limit })
          resolve(res)
        }).catch(error =>{
          reject(error)
        })
      })
    },
    AddCart({ dispatch, commit, state }, payload){
      const { item_id,num } = payload
      const { page,limit } = state
      return new Promise((resolve, reject) => {
        addCart({ item_id,num }).then(res=>{
          dispatch('GetCartList',{ page,limit })
          resolve(res)
        }).catch(error =>{
          reject(error)
        })
      })
    },
    UpdateCart({ dispatch, commit, state }, payload){
      const { cart_id,num } = payload
      const { page,limit } = state
      return new Promise((resolve, reject) => {
        updateCart({ cart_id,num }).then(res=>{
          dispatch('GetCartList',{ page,limit })
          resolve(res)
        }).catch(error =>{
          reject(error)
        })
      })
    },
    SelectCartOne({ commit, state }, payload){
      const { index } = payload
      const { cartList } = state
      const temp = []
      cartList.map(((item, cindex)=> {
        if(cindex == index && !item.disabled){
          temp.push(Object.assign({},item,{isSelect:!item.isSelect}))
        }else{
          temp.push(Object.assign({},item))
        }
      }))
      commit('SET_CARTLIST', temp)
    },
    SelectCartAll( { commit, state }, payload){
      const { selectAll } = payload
      const { cartList } = state
      const temp = []
      cartList.map(((item, cindex)=> {
        temp.push(Object.assign({},item,{ isSelect:item.disabled ? false : selectAll }))
      }))
      commit('SET_CARTLIST', temp)
    },
    SetCartListFilter( { commit, state }, payload ){
      const { page,limit } = payload
      commit('SET_PAGE', page)
      commit('SET_LIMIT', limit)
    },
    ResetCartList( { commit, state }){
      commit('RESET_STATE',getDefaultState())
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/cart.js